import * as React from 'react';
import type { SVGProps } from 'react';
const SvgDesignElementWh4 = (props: SVGProps<SVGSVGElement>) => (
    <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} fill="none" viewBox="0 0 24 24" {...props}>
        <path fill="#1D4ED8" d="M12 0v24l12-11.913z" />
        <path fill="#000" d="M0 0v24l12-11.913z" />
    </svg>
);
export default SvgDesignElementWh4;
